import React, { createContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRadioGroupState } from '@react-stately/radio';
import { useRadioGroup } from '@react-aria/radio';
import { VisuallyHidden } from '@react-aria/visually-hidden';


export const RadioContext = createContext(null);

const RadioGroup = function RadioGroup(props) {
  const {
    activeValue,
    children,
    label,
    showLabel,
    className,
  } = props;
  const state = useRadioGroupState({ ...props, defaultValue: activeValue });
  const { radioGroupProps, labelProps } = useRadioGroup(props, state);

  useEffect(() => state.setSelectedValue(activeValue), [activeValue]);

  radioGroupProps['aria-orientation'] = null;

  const labelEl = <span {...labelProps}>{label}</span>;

  return (
    <div className={className} {...radioGroupProps}>
      {showLabel ? labelEl : <VisuallyHidden>{labelEl}</VisuallyHidden>}
      <RadioContext.Provider value={state}>{children}</RadioContext.Provider>
    </div>
  );
};

RadioGroup.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  activeValue: PropTypes.string,
  showLabel: PropTypes.bool,
};

RadioGroup.defaultProps = {
  className: '',
  activeValue: '',
  showLabel: true,
};

export default RadioGroup;
